import React from "react";
import Utils from "Utils/utils";
import { ReactComponent as WriteWithAiIcon } from "Assets/svg/spintax/writeWithAiSvg.svg";

const WandButton = ({ action = () => { } }) => {
  return (
    <div
      className="aiMagicWandBtn"
      onClick={e => {
        Utils.preventDefaultFn(e);
        action();
      }}
    >
      <WriteWithAiIcon />
    </div>
  );
};

export default WandButton;
